"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getCarCatalogImg = void 0;
var getCarCatalogImg = function (brand) {
    try {
        return require("../../assets/images/catalog/".concat(brand.toLowerCase(), ".webp"));
    }
    catch (error) {
        console.error("Image not found for brand: ".concat(brand));
        return '';
    }
};
exports.getCarCatalogImg = getCarCatalogImg;
